/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getWarehouses = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
  };
  if (values != undefined) {
    const { warehouse_code, warehouse_name, warehouse_address, is_active } = values;
    object.warehouse_code = warehouse_code;
    object.warehouse_name = warehouse_name;
    object.warehouse_address = warehouse_address;
    object.is_active = is_active;
  }

  try {
    return await clientService.getApi(`warehouses`, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const createWarehouse = async (accessToken, body) => {
  try {
    const domain = `warehouses`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteWarehouse = async (accessToken, body) => {
  const { id } = body;
  try {
    const domain = `warehouses/` + id;
    return await clientService.deleteApiQueryString(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const updateWarehouse = async (accessToken, body) => {
  const { id } = body;
  try {
    const domain = `warehouses/` + id;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
